"use strict";

var forceReflow = function forceReflow(node) {
  return node && node.scrollTop;
};
export default forceReflow;